/**
 * BrandsFeatured.tsx — Gold Garage Door / Brands · Section 3/8
 * Navy · spotlight on the 3 biggest brands (B&D, Merlin, ATA) · alternating rows.
 * Each = logo + what we do + common issues we fix. SEO-rich brand copy.
 * MOBILE: real <style> media queries.
 * 10WEB AI: keep <img> + <style>. Wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const NAVY2 = "#0f2347";
const GOLD = "#F5A623";

/** check — DO NOT REPLACE WITH IMG */
const Check = () => <svg data-icon-container="lucide-do-not-replace" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{
  flexShrink: 0,
  marginTop: "3px"
}}><polyline points="20 6 9 17 4 12" /></svg>;
const FEATURED = [{
  logo: "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/b5706f1be_58dae4e4d_BD_Australia_Logo-removebg-preview.png?v=wz7me0qyug",
  name: "B&D",
  tag: "Australia's #1 residential brand",
  body: "B&D is on more Sydney garages than any other brand. We service the full range — Panelift, Roll-A-Door and Firmadoor — plus B&D openers like the Controll-A-Door range.",
  fixes: ["Controll-A-Door motor faults", "Panelift spring & cable repairs", "Remote & keypad reprogramming", "Full Roll-A-Door replacements"]
}, {
  logo: "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/24bd15fa9_a095621ff_Merlin-Logo-Positive-removebg-preview.png?v=cx8h3ho3nle",
  name: "Merlin",
  tag: "Openers, motors & remotes",
  body: "Merlin powers a huge share of Sydney's automatic doors. We diagnose and repair every Merlin opener, from the Professional series to MyQ smart units, and stock genuine remotes.",
  fixes: ["MyQ & smart-opener setup", "Merlin motor & gear repairs", "Genuine remote replacement", "Safety-beam realignment"]
}, {
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/ata-logo-min-300x226.png.webp",
  name: "ATA",
  tag: "Automation & control systems",
  body: "ATA (Automatic Technology) builds some of the most reliable openers and controllers in the country. We handle GDO motor faults, TrioCode remotes and SecuraCode programming.",
  fixes: ["GDO-series motor repairs", "TrioCode remote pairing", "Controller board diagnostics", "Travel & force recalibration"]
}];
export default function BrandsFeatured() {
  return <section id="brands-featured" style={{
    background: `radial-gradient(ellipse at 20% 0%, #14254d 0%, ${NAVY} 55%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <style>{`
        .bf-row { display: grid; grid-template-columns: 0.85fr 1.15fr; gap: 3rem; align-items: center; }
        .bf-row.rev .bf-logo { order: 2; }
        .bf-fixes { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem 1.25rem; }
        @media (max-width: 820px) {
          .bf-row, .bf-row.rev { grid-template-columns: 1fr; gap: 1.75rem; }
          .bf-row.rev .bf-logo { order: 0; }
          .bf-fixes { grid-template-columns: 1fr; }
          #brands-featured { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}><filter id="grain-bf"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter><rect width="100%" height="100%" filter="url(#grain-bf)" /></svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />

      <div style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        textAlign: "center",
        maxWidth: "620px",
        margin: "0 auto 3.5rem"
      }}>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD,
          textTransform: "uppercase"
        }}>Brand Spotlight</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.65rem, 6vw, 2.6rem)",
          color: "#FFFFFF",
          lineHeight: 1.15,
          margin: "0.75rem 0 0"
        }}>The big three, in depth</h2>
        </div>

        <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "2.5rem"
      }}>
          {FEATURED.map((b, i) => <div key={i} className={`bf-row${i % 2 === 1 ? " rev" : ""}`} style={{
          background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: "18px",
          padding: "2.25rem"
        }}>
              {/* logo panel */}
              <div className="bf-logo" style={{
            background: NAVY2,
            border: `1px solid ${GOLD}30`,
            borderRadius: "14px",
            padding: "2.5rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            minHeight: "180px"
          }}>
                <img src={b.logo} alt={`${b.name} garage doors and openers serviced by Gold Garage Door`} width={160} height={56} loading="lazy" decoding="async" style={{
              maxHeight: "56px",
              maxWidth: "180px",
              width: "auto",
              objectFit: "contain",
              filter: "brightness(0) invert(1)",
              opacity: 0.9
            }} />
                <span style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.78rem",
              fontWeight: 700,
              color: GOLD,
              letterSpacing: "0.05em",
              textAlign: "center"
            }}>{b.tag}</span>
              </div>

              {/* copy */}
              <div>
                <h3 style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: "1.6rem",
              color: "#fff",
              marginBottom: "0.6rem"
            }}>{b.name} repairs & installs</h3>
                <p style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.98rem",
              color: "rgba(255,255,255,0.72)",
              lineHeight: 1.7,
              marginBottom: "1.25rem"
            }}>{b.body}</p>
                <div className="bf-fixes">
                  {b.fixes.map((fx, j) => <div key={j} style={{
                display: "flex",
                gap: "0.6rem",
                alignItems: "flex-start"
              }}>
                      <Check />
                      <span style={{
                  fontFamily: "'Manrope', sans-serif",
                  fontSize: "0.9rem",
                  color: "rgba(255,255,255,0.85)",
                  lineHeight: 1.4
                }}>{fx}</span>
                    </div>)}
                </div>
              </div>
            </div>)}
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>
    </section>;
}